interface ConversationItem {
  Speaker: number;
  Text: string;
}

interface ConversationProps {
  conversation: string;
}

const ConversationSection = ({ conversation }: ConversationProps) => {
  const conversationData: ConversationItem[] = conversation
    ? JSON.parse(conversation)
    : [];

  const getSpeakerDetails = (speaker: number) => {
    if (speaker === 2) {
      return {
        name: "Speaker Two",
        initials: "ST",
        isPrimary: true,
      };
    }

    return {
      name: "Speaker One",
      initials: "SO",
      isPrimary: false,
    };
  };

  return (
    <div className="conversation-wrapper">
      {conversationData?.map((item, index) => {
        const { name, initials, isPrimary } = getSpeakerDetails(item.Speaker);

        return (
          <div
            key={index}
            className={`conversation-item ${isPrimary ? "right" : "left"}`}
          >
            {!isPrimary && (
              <div className="conversation-avatar conversation-avatar--left">
                {initials}
              </div>
            )}

            <div className="conversation-content">
              <div className="conversation-meta">
                <span className="name">{name}</span>
              </div>

              <div
                className={`conversation-bubble ${
                  isPrimary
                    ? "conversation-bubble--right"
                    : "conversation-bubble--left"
                }`}
              >
                {item.Text}
              </div>
            </div>

            {isPrimary && (
              <div className="conversation-avatar conversation-avatar--right">
                {initials}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ConversationSection;
